// searchQueries.ts

import { Config } from './InfoEventConfig';

// Start of the visitor's current day. plone.app.querystring maps
// afterToday to "value >= NOW" (not 00:00), which would drop an occasion
// from the result the moment it starts — but the client-side rule keeps
// it visible until 23:59 of the start day. Sending an explicit
// start-of-day bound keeps that rule decisive; the site search rewrites
// afterToday the same way server-side (services/available_indexes.py).
const startOfToday = () => {
  const start = new Date();
  start.setHours(0, 0, 0, 0);
  return start.toISOString();
};

export const getNonSubjectSearchQuery = (uid: string) => [
  {
    i: 'occasion_event_type',
    o: 'plone.app.querystring.operation.string.is',
    v: Config.portalType,
  },
  {
    i: 'show_from',
    o: 'plone.app.querystring.operation.date.beforeToday',
  },
  {
    i: 'show_until',
    o: 'plone.app.querystring.operation.date.afterToday',
  },
  // Past occasions without show_until are indexed with a far-future
  // sentinel and would match forever, blocking result slots (#1708).
  // Occasions without a start date are indexed far-future as well and
  // survive this criterion (e.g. rolling intake). largerThan is an
  // inclusive range-min against the start of the current day, so the
  // client-side "visible until 23:59 of the start day" rule still
  // decides the exact cut-off.
  {
    i: 'occasion_start',
    o: 'plone.app.querystring.operation.date.largerThan',
    v: startOfToday(),
  },
  {
    i: 'linked_products',
    o: 'plone.app.querystring.operation.selection.any',
    v: [uid],
  },
];

export const getSubjectSearchQuery = (subjects: string[], uid: string) => [
  ...getNonSubjectSearchQuery(uid),
  {
    i: 'Subject',
    o: 'plone.app.querystring.operation.selection.any',
    v: subjects,
  },
];
